import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { pollLongRunningOperationListenerSaga } from './poll-long-running-operation';

export function* rootSaga(): SagaIterator {
    yield all([fork(pollLongRunningOperationListenerSaga)]);
}
